import { render, staticRenderFns } from "./ChatFooter.vue?vue&type=template&id=7c74df38&scoped=true&"
import script from "./ChatFooter.vue?vue&type=script&lang=js&"
export * from "./ChatFooter.vue?vue&type=script&lang=js&"
import style0 from "./ChatFooter.vue?vue&type=style&index=0&id=7c74df38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c74df38",
  null
  
)

export default component.exports